export default {
    title: 'Proficiency levels',
    description: 'Customize the competency assessment levels. You can have between 3 and 6.',
    columnFrench: 'French',
    columnEnglish: 'English',
    levelLabelPlaceholder: 'Level label',
    addLevel: 'Add a level',
    iconNames: {
        mastered: 'Mastered',
        almostAcquired: 'Almost acquired',
        inProgress: 'In progress',
        notMet: 'Not met',
        trophy: 'Trophy',
        award: 'Award',
        medal: 'Medal',
        star: 'Star',
        crown: 'Crown',
        target: 'Target',
        flag: 'Flag',
        excellence: 'Excellence',
        thumbsUp: 'Thumbs up',
        thumbsDown: 'Thumbs down',
        progress: 'Progress',
        regression: 'Regression',
        results: 'Results',
        measure: 'Measure',
        validated: 'Validated',
        failure: 'Failure',
        ongoing: 'Ongoing',
        idea: 'Idea',
        liftoff: 'Liftoff',
        graduate: 'Graduate',
    },
    validation: {
        labelRequired: 'A label is required.',
        minLevels: 'You must have at least {{count}} levels.',
        maxLevels: 'You can have at most {{count}} levels.',
    },
    saveSuccess: 'Proficiency levels saved successfully.',
};
